import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState, type FC } from "react";

export const PiiGuidanceNotice: FC<{ analyticsId: string }> = ({ analyticsId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Typography variant="caption" color="text.secondary">
        Don’t enter personal or confidential information
      </Typography>
      <Button
        data-analytics-id={`pii-guidance-${analyticsId}`}
        size="small"
        sx={{ minWidth: 0, pl: 1 }}
        onClick={() => setOpen(true)}
      >
        <InfoOutlined color="primary" />
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Using AI prompts responsibly</DialogTitle>
        <DialogContent>
          <p>
            Content entered here will be sent to AI to help generate communications, designs, or
            surveys.
          </p>
          <p>Please avoid including personal, confidential, or sensitive information.</p>
          <p>Examples include:</p>
          <ul>
            <li>Names, email addresses, phone numbers</li>
            <li>HR or employee details</li>
            <li>Customer data</li>
            <li>Security credentials or internal secrets</li>
          </ul>
          <p>
            When editing a Communication, you can use merge tags to add personalized information for
            each recipient.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            data-analytics-id={`pii-guidance-understand-${analyticsId}`}
            variant="text"
            color="primary"
            onClick={() => setOpen(false)}
          >
            I understand
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
